var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKey2Line(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#716E6E",
    d: "M8.96312 9.85724L15.504 3.31641L16.6823 4.49474L15.504 5.67391L17.5656 7.73557L16.3873 8.91474L14.3248 6.85224L13.1465 8.03057L14.914 9.79807L13.7356 10.9772L11.9681 9.20891L10.1415 11.0356C10.7085 11.8972 10.9359 12.9386 10.7797 13.9582C10.6235 14.9778 10.0948 15.9033 9.29584 16.5557C8.49686 17.2081 7.48436 17.5411 6.4541 17.4903C5.42384 17.4395 4.44902 17.0084 3.71812 16.2806C2.98564 15.5508 2.55064 14.5748 2.49766 13.5423C2.44469 12.5097 2.77752 11.4943 3.43146 10.6934C4.08541 9.89256 5.01376 9.36344 6.03609 9.2089C7.05841 9.05436 8.10168 9.28545 8.96312 9.85724ZM8.43229 15.1014C8.67505 14.8718 8.86932 14.5958 9.0036 14.2898C9.13789 13.9839 9.20947 13.6541 9.21412 13.3199C9.21877 12.9858 9.15638 12.6541 9.03066 12.3445C8.90493 12.0349 8.71841 11.7537 8.48213 11.5174C8.24584 11.2811 7.96459 11.0946 7.65499 10.9689C7.34539 10.8431 7.01372 10.7808 6.6796 10.7854C6.34547 10.7901 6.01567 10.8616 5.70969 10.9959C5.4037 11.1302 5.12774 11.3245 4.89812 11.5672C4.44273 12.0387 4.19074 12.6702 4.19643 13.3257C4.20213 13.9812 4.46505 14.6083 4.92857 15.0718C5.39209 15.5353 6.01912 15.7982 6.67462 15.8039C7.33011 15.8096 7.96161 15.5576 8.43312 15.1022L8.43229 15.1014Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKey2Line);
export default __webpack_public_path__ + "static/media/key-2-line.4cbe394dfe51017ab5ef1ca169efa545.svg";
export { ForwardRef as ReactComponent };